import React from "react"
import { Card, CardContent, Typography, makeStyles } from "@material-ui/core"
import { useTranslation } from "react-i18next"
import RecentActivityList from "./RecentActivityList"
import { useSelector } from "react-redux"
import { Skeleton } from "@material-ui/lab"
import { roles } from "../../../data/roles"

const useStyles = makeStyles((theme) => ({
	root: {
		maxHeight: 1170,
	},
	title: {
		color: theme.palette.grey.D300,
		fontWeight: 600,
		padding: "4px 10px",
	},
	recentTitle: {
		color: theme.palette.grey.D100,
		fontWeight: 600,
		padding: "4px 10px",
		fontStyle: "italic",
	},
	cardBody: {
		padding: 0,
		"&:last-child": {
			paddingBottom: 0,
		},
	},
	NoData: {
		minHeight: 510,
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
}))

const SkeletonList = () => {
	return Array(4)
		.fill()
		.map((data, i) => (
			<div key={i} style={{ padding: "0px 15px" }}>
				<Skeleton key={i} width={"100%"} height={80} />
			</div>
		))
}

const RecentActivity = () => {
	const classes = useStyles()
	const [t] = useTranslation("global")

	const rows = useSelector((state) => state.auditReducer?.auditDetailsList || [])
	const isLoading = useSelector((state) => state.dashboard?.isLoading)
	const isCaseUser = useSelector((state) => state?.authtentication?.user?.user?.roles)?.includes(roles?.Case_User)
	const isCaseAdmin = useSelector((state) => state?.authtentication?.user?.user?.roles)?.includes(roles?.Case_Administrator)

	const handleClick = (e, data) => {
		console.log("handleClick", data)
	}

	return (
		<Card className={classes.root}>
			<CardContent className={classes.cardBody}>
				<div style={{ display: "flex", alignItems: "center", justifyContent: "space-around", padding: "24px 0 10px 0" }}>
					<Typography variant="subtitle1" className={classes.title}>
						{t("dashboard.recentActivityText")}
					</Typography>
					<Typography variant="caption" className={classes.recentTitle}>
						{`${t("dashboard.last")} ${rows?.length > 0 ? rows?.length : ""} ${t("dashboard.activity")}`}
					</Typography>
				</div>
				{isLoading ? (
					<SkeletonList />
				) : rows?.length ? (
					<RecentActivityList rows={rows} handleClick={handleClick} />
				) : (
					<Typography variant="subtitle1" className={classes.NoData}>
						{t("dashboard.noDataFound")}
					</Typography>
				)}
			</CardContent>
		</Card>
	)
}

export default RecentActivity
